/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
 */
import mergeProps from "@/router/utils/mergeProps";
import eventTypeSettingsRoutesFn from "@/router/scheduler/eventTypeSettingsRoutesFn";
import redirectByName from "@/router/utils/redirectByName.js";
let EmptyRouterView = () => import(/* webpackChunkName: "Login" */ '@/core/components/EmptyRouterView.vue')
let CoachingMain = () => import(/* webpackChunkName: "Login" */ '@/core/modules/coach/Coaching/CoachingMain.vue')
let CoachingProcessList = () => import(/* webpackChunkName: "Login" */ '@/core/modules/coach/Coaching/Processes/CoachingProcessList.vue')
let ProgramTemplateList = () => import(/* webpackChunkName: "Login" */ '@/core/modules/coach/Coaching/Templates/ProgramTemplateList.vue')
let CoachingProcessDetails = () => import(/* webpackChunkName: "Login" */ '@/core/modules/coach/Coaching/Processes/CoachingProcessDetails.vue')
let CoachingTemplateDetails = () => import(/* webpackChunkName: "Login" */ '@/core/modules/coach/Coaching/Templates/ProgramTemplateDetails.vue')
// let CoachingProcessDetails = () => import(/* webpackChunkName: "Login" */ '@/core/client/coach/Coaching/Processes/CoachingProcessDetails')
// let CoachingTemplateDetails = () => import(/* webpackChunkName: "Login" */ '@/core/client/coach/Coaching/Templates/CoachingTemplateDetails')


export default [

	{
		path: 'coaching',
		component: EmptyRouterView,
		props: mergeProps,
		children: [
			{
				path: 'process',
				redirect: redirectByName('ProcessesMain'),
			},

			{
				path: '',
				redirect: redirectByName("CoachingMainCoach", {category: "processes"}),
				name: 'ProcessesMain',
				component: CoachingMain,
				props: mergeProps,
				children:[
					{
						path: ':category',
						name: 'CoachingMainCoach',
						components: {
							processes: CoachingProcessList,
							templates: ProgramTemplateList
						},
						props: route => ({
							...mergeProps(route),
							responseParam: route.query.res
						}),
						children:[
							...eventTypeSettingsRoutesFn({
								mainRouteName: "WizardTemplateEventType",
								backRouteName: "CoachingMainCoach",
								schedulerGeneralAvailabilityRoute: "SchedulerGeneralAvailability"
							})
						]

					},
				]
			},
			{
				path: 'processes/:programId',
				name: 'ProcessDetailsCoach',
				component: CoachingProcessDetails,
				children:[
					...eventTypeSettingsRoutesFn({
						mainRouteName: "ProcessEventType",
						backRouteName: "ProcessDetailsCoach",
						schedulerGeneralAvailabilityRoute: "SchedulerGeneralAvailability"
					})
				]
			},
			{
				path: 'templates/:templateId',
				name: 'ProgramTemplateDetailsCoach',
				component: CoachingTemplateDetails,
				children:[
					...eventTypeSettingsRoutesFn({
						mainRouteName: "ProgramTemplateEventType",
						backRouteName: "ProgramTemplateDetailsCoach",
						schedulerGeneralAvailabilityRoute: "SchedulerGeneralAvailability"
					})
				]
			},

			{
				path: '',
				redirect: redirectByName("CoachingMainCoach", {category: "processes"}),
				name: "CoachingProcessMainCoach"
			},
			{
				path: '',
				redirect: redirectByName("CoachingMainCoach", {category: "templates"}),
				name: "CoachingTemplatesMainCoach"
			},



		]
	},




]


